export default __webpack_public_path__ + "static/media/2277.65c9ac29.png";